var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('webix-ui',{attrs:{"config":_vm.config},model:{value:(_vm.locations),callback:function ($$v) {_vm.locations=$$v},expression:"locations"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }